import { render, staticRenderFns } from "./DialogListaDePedido.vue?vue&type=template&id=2ad5482f"
import script from "./DialogListaDePedido.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogListaDePedido.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports